// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { WebGrpcDecodedDataSchema } from './WebGrpcDecodedDataSchema'
import { JsonValueSchema } from '../inputTypeSchemas/JsonValueSchema'
import { EndpointSourceSchema } from '../inputTypeSchemas/EndpointSourceSchema'

/////////////////////////////////////////
// HAR ENTRY SCHEMA
/////////////////////////////////////////

export const HarEntrySchema = z.object({
  sources: EndpointSourceSchema.array(),
  id: z.string(),
  tenantId: z.string().nullable(),
  applicationId: z.string(),
  credentialsId: z.string().nullable(),
  hash: z.string(),
  requestHost: z.string().nullable(),
  request: JsonValueSchema,
  response: JsonValueSchema,
  timings: JsonValueSchema,
  webSocketMessages: JsonValueSchema.nullable(),
  isClosed: z.boolean().nullable(),
  pages: z.string().array(),
  endpointCandidateId: z.string().nullable(),
  webGrpcDecodedData: z.lazy(() => WebGrpcDecodedDataSchema).nullable().optional(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date().nullable(),
})

export type HarEntry = z.infer<typeof HarEntrySchema>

export default HarEntrySchema;
